exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".contract-selection{background-color:#eee;padding-bottom:16px;padding-top:16px}.address-search-image{margin-left:34px}.offer-image{margin-top:-50px;z-index:1;position:relative}.selection-section-title{color:#545454;position:relative;z-index:2}@media (max-width:768px){.plans-info-box{margin-top:20px}}.plan-info-list-item{margin:8px 0;color:#545454}@media (max-width:1200px){.contract-selection-summery-desktop{display:none}}.contract-selection-summery-mobile{display:none}@media (max-width:1200px){.contract-selection-summery-mobile{display:initial}}.contract-selection-summery-mobile .summary-container{padding:0;border:0}@media (max-width:1200px){.contract-selection-summery-mobile .summary-container{display:initial;margin-left:0;margin-right:0}}.selection-heading-number{background-color:#545454;color:#fff}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/Plans/Selection/Selection.scss
 ** module id = 1211
 ** module chunks = 0
 **/